export enum ActivityPrototypeWarning {
  Fund = 'Fund'
}
